<script setup lang="ts">
const props = defineProps<{
  title: string;
}>();

const id = uniqueId("artcover");
const titleSplit = computed(() => props.title.split(" "));
const title1 = computed(
  () => (titleSplit.value.length && titleSplit.value[0]) || props.title,
);
const title2 = computed(
  () => (titleSplit.value.length > 1 && titleSplit.value[1]) || "",
);
</script>

<template>
  <svg
    class="songs-by-language-art-cover bg"
    height="100%"
    width="100%"
    viewBox="0 0 100 100"
  >
    <defs>
      <linearGradient
        :id="`gradient${id}`"
        x1="0"
        y1="100%"
        x2="100%"
        y2="0"
      >
        <stop
          offset="0%"
          stop-color="#c6edfa"
        />
        <stop
          offset="50%"
          stop-color="#8be5f8"
        />
        <stop
          offset="100%"
          stop-color="#7261f8"
        />
      </linearGradient>
    </defs>
    <text
      x="10"
      y="20"
      class="title"
      :class="{ 'title-sm': !!title2 }"
      dominant-baseline="auto"
      text-anchor="left"
      fill="white"
    >
      {{ title1 }}
    </text>
    <text
      v-if="title2"
      x="10"
      y="35"
      class="title title-sm"
      dominant-baseline="auto"
      text-anchor="left"
      fill="white"
    >
      {{ title2 }}
    </text>
    <foreignObject
      width="30"
      height="30"
      x="79"
      y="75"
    >
      <FAIcon class="fa-light fa-globe" />
    </foreignObject>
  </svg>
</template>

<style scoped lang="postcss">
.bg {
  @apply aspect-square rounded-lg;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    195deg,
    #48b4c1 0%,
    #48b1bf 22.4485%,
    #4791a9 42.93%,
    #477997 62.12%,
    #46678b 76.07%,
    #465c83 86.31%,
    #465981 100%
  );
  animation: fadeIn 0.2s ease forwards;
}

.title {
  @apply font-display font-bold leading-4 text-white;
  line-height: 10px;
  font-size: 15px;
}
.title.title-sm {
  font-size: 13px;
}

.fa-globe {
  @apply text-light-100/50;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
